import createClient from "openapi-fetch";

import type { components as AdminComponents, paths as AdminPaths } from "./admin.generated";
import type { components as PublicComponents, paths as PublicPaths } from "./public.generated";

export type { AdminPaths, PublicPaths };

export type UserResponse = PublicComponents["schemas"]["UserResponse"];
export type LoginRequest = PublicComponents["schemas"]["LoginRequest"];
export type LoginResponse = PublicComponents["schemas"]["LoginResponse"];
export type UpdateMeRequest = PublicComponents["schemas"]["UpdateMeRequest"];
export type UpdateMeResponse = PublicComponents["schemas"]["UpdateMeResponse"];
export type LogoutAllRequest = PublicComponents["schemas"]["LogoutAllRequest"];
export type LogoutAllResponse = PublicComponents["schemas"]["LogoutAllResponse"];

export type AdminUserSummary = AdminComponents["schemas"]["AdminUserSummary"];
export type AdminUserListResponse = AdminComponents["schemas"]["AdminUserListResponse"];
export type AdminUserDetailResponse = AdminComponents["schemas"]["AdminUserDetailResponse"];
export type AdminUserPatchRequest = AdminComponents["schemas"]["AdminUserPatchRequest"];
export type AdminUserUnlockResponse = AdminComponents["schemas"]["AdminUserUnlockResponse"];
export type AdminApiKeyDetail = AdminComponents["schemas"]["AdminApiKeyDetail"];
export type AdminApiKeyCreatedResponse = AdminComponents["schemas"]["AdminApiKeyCreatedResponse"];
export type AdminCreateApiKeyRequest = AdminComponents["schemas"]["AdminCreateApiKeyRequest"];
export type AdminStatsOverviewResponse = AdminComponents["schemas"]["AdminStatsOverviewResponse"];
export type AdminStatsUsageResponse = AdminComponents["schemas"]["AdminStatsUsageResponse"];
export type EndpointCountItem = AdminComponents["schemas"]["EndpointCountItem"];
export type UsageBucketItem = AdminComponents["schemas"]["UsageBucketItem"];
export type AdminAuditEntrySummary = AdminComponents["schemas"]["AdminAuditEntrySummary"];
export type Tier = AdminComponents["schemas"]["Tier"];
export type Role = AdminComponents["schemas"]["Role"];

/** Typed client for public auth and profile routes. Uses same-origin cookies. */
export const publicApiClient = createClient<PublicPaths>({
  baseUrl: "",
  credentials: "include",
});

/** Typed client for admin routes (Epic 6 Tasks 6.3+). Uses same-origin cookies. */
export const adminApiClient = createClient<AdminPaths>({
  baseUrl: "",
  credentials: "include",
});
